import type { CSSProperties } from 'react';

export function Icon({ name, size = 22, filled = false }: { name: string; size?: number; filled?: boolean }) {
  return (
    <span
      aria-hidden="true"
      className="material-symbols-outlined"
      style={{ '--icon-size': `${size}px`, '--icon-fill': filled ? 1 : 0 } as CSSProperties}
    >
      {name}
    </span>
  );
}
